module.exports = __webpack_public_path__ + "img/pumpkin.8fe35577.png";